import React from 'react'
import Main from '../cpn/Main'
import {Row, Col} from 'antd'
import classes from './sys.module.css';
import { useNavigate } from 'react-router-dom';
import deptUser from '../svg/deptUser.svg'
import password from '../svg/password.svg'
import post from '../svg/post.svg'
import balance  from '../svg/balance .svg'
import ledger  from '../svg/ledger.svg'
import arap  from '../svg/arap.svg'
import fundTransList  from '../svg/fundTransList.svg'
import fundAccount  from '../svg/fundAccount.svg'
import StatForm  from '../svg/StatForm.svg'
import client  from '../svg/client.svg'
import goods  from '../svg/goods.svg'
import balanceType  from '../svg/balanceType.svg'
import dept  from '../svg/dept.svg'
function SysIndex() {

    const navi = useNavigate();
    return (
        <Main >
            <Row gutter={20}>
                {!localStorage.getItem('ess_menu_id').includes('90') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/LedgerList')
                    }}
                >
                    <img src={ledger} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>团队</div>
                </Col>}   
                {!localStorage.getItem('ess_menu_id').includes('84') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/BalanceList')
                    }}
                >
                    <img src={balance} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>收支</div>
                </Col>}   
                {!localStorage.getItem('ess_menu_id').includes('86') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/ArapAddOld')
                    }}
                >
                    <img src={arap} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>下账</div>
                </Col>}   
                {!localStorage.getItem('ess_menu_id').includes('87') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/FundList')
                    }}
                >
                    <img src={fundTransList} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>转账</div>
                </Col>}   
               
                {(localStorage.getItem('eu_role')==='2' ||(localStorage.getItem('ess_menu_id').includes('85'))) && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/StatIndex')
                    }}
                >
                    <img src={StatForm} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>统计报表</div>
                </Col>}   
                
                {!localStorage.getItem('ess_menu_id').includes('89') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/ClientList')
                    }}
                >
                    <img src={client} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>客户</div>
                </Col>}   
                {!localStorage.getItem('ess_menu_id').includes('88') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/GoodsList')
                    }}
                >
                    <img src={goods} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>产品</div>
                </Col>}   
                {(localStorage.getItem('eu_role')==='1' ||(localStorage.getItem('ess_menu_id').includes('85'))) && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/StatIndexPersonal')
                    }}
                >
                    <img src={StatForm} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>部门利润</div>
                </Col>}   
                <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/Password')
                    }}
                >
                    <img src={password} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>修改密码</div>
                </Col>            
              
                {!localStorage.getItem('ess_menu_id').includes('82') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/AccountList')
                    }}
                >
                    <img src={fundAccount} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>资金账户</div>
                </Col>}                  
                {!localStorage.getItem('ess_menu_id').includes('83') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/BalanceTypeList')
                    }}
                >
                    <img src={balanceType} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>收支类型</div>
                </Col>}   
                {(localStorage.getItem('eu_role')==='2' ||(localStorage.getItem('ess_menu_id').includes('78'))) && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/DeptList')
                    }}
                >
                    <img src={dept} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>部门</div>
                </Col>   }
                {(localStorage.getItem('eu_role')==='2' ||(localStorage.getItem('ess_menu_id').includes('79'))) && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/UserList')
                    }}
                >
                    <img src={deptUser} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>用户</div>
                </Col>}   
                {!localStorage.getItem('ess_menu_id').includes('81') && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/PostList')
                    }}
                >
                    <img src={post} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>岗位</div>
                </Col>}   
              
                {(localStorage.getItem('eu_role')==='2' ||(localStorage.getItem('ess_menu_id').includes('76'))) &&<Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/ClientTypeList')
                    }}
                >
                    <img src={client} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>客户类型</div>
                </Col>}   
                {(localStorage.getItem('eu_role')==='2' ||(localStorage.getItem('ess_menu_id').includes('77'))) && <Col 
                    span={2} 
                    className={classes.mainItem} 
                    onClick={() => {
                        navi('/GoodsTypeList')
                    }}
                >
                    <img src={goods} width={60} style={{marginBottom:"10px"}} alt=''/>
                    <div style={{textAlign:'center'}}>产品类型</div>
                </Col>} 
            </Row>
           
        </Main>
    )
}

export default SysIndex